/**
 * Bring Your Own Employer (migratie 202).
 *
 * Professional Cockpit: /api/v1/professional/byoe
 * Academie-korting:     /api/v1/professional/academy/discount
 * Publiek (uitnodigingslink): /api/byoe
 * Registratie: POST /api/auth/register met `byoe_token` + `byoe_akkoord`
 */
import api from './api';

const d = <T,>(r: { data: { data: T } }) => r.data.data;

export type ByoeStatus = 'PENDING_REGISTRATION' | 'REGISTERED' | 'VERIFIED' | 'REJECTED' | 'REVOKED' | 'EXPIRED';

export interface ByoeUitnodiging {
  id: string;
  email: string;
  bedrijfsnaam: string;
  contact_naam: string | null;
  status: ByoeStatus;
  expires_at: string;
  registered_at: string | null;
  verified_at: string | null;
  created_at: string;
  opdrachtgever: { bedrijfsnaam: string; kvk_nummer: string | null; onboarding_afgerond: boolean } | null;
  kan_bevestigen: boolean;
  is_byoe_verified: boolean;
  fee_start_date: string | null;
  fee_verlaagd_tot: string | null;
  huidige_fee_percentage: number | null;
}

export interface AcademieKorting {
  standaard_pct: number;
  premium_pct: number;
  korting_pct: number;
  platformfee_pct: number;
  premium_actief: boolean;
  premium_jaren: number;
  vervaldatum: string | null;
  premium_tot_en_met: string | null;
  aangebrachte_opdrachtgevers: number;
}

export interface ByoeOverzicht {
  mag_uitnodigen: boolean;
  uitnodigingen: ByoeUitnodiging[];
  academie: AcademieKorting;
}

export interface ByoeUitnodigingInfo {
  email: string;
  bedrijfsnaam: string;
  contact_naam: string | null;
  professional_naam: string;
  expires_at: string;
  akkoord_tekst: string;
  fee_pct: number;
  standaard_fee_pct: number;
}

export const byoeApi = {
  overzicht: () => api.get('/v1/professional/byoe').then(d<ByoeOverzicht>),
  nodigUit: (invoer: { email: string; bedrijfsnaam: string; contact_naam?: string }) =>
    api.post('/v1/professional/byoe/invites', invoer).then(d<ByoeUitnodiging>),
  trekIn: (id: string) => api.delete(`/v1/professional/byoe/invites/${id}`),
  wijsAf: (id: string) => api.post(`/v1/professional/byoe/invites/${id}/afwijzen`),
  bevestig: (inviteId: string) => api.post('/v1/professional/byoe/confirm-match', { invite_id: inviteId }),
  academieKorting: () => api.get('/v1/professional/academy/discount').then(d<AcademieKorting>),

  uitnodiging: (token: string) => api.get(`/byoe/invite/${token}`).then(d<ByoeUitnodigingInfo>),
};
